// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__2FGO7","list":"PatternAutocomplete_list__2oTfi"};